import { render } from "./ConfirmOrder.vue?vue&type=template&id=790521ac&scoped=true"
import script from "./ConfirmOrder.vue?vue&type=script&lang=js"
export * from "./ConfirmOrder.vue?vue&type=script&lang=js"

import "./ConfirmOrder.vue?vue&type=style&index=0&id=790521ac&scoped=true&lang=scss"

import exportComponent from "/var/www/test.adx-co.jp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-790521ac"]])

export default __exports__